/* global lumesseAnalytics */

SU.injectedScripts.push(function($) {
    var elapsedTime = 0,
        retryDelay  = 100,
        timeout     = 5000,
        mode        = 'cards',
        dictionary  = new Map([
            ['Closing Date', 'Dyddiad Cau'],
            ['Details', 'Manylion'],
            ['It appears that this service is currently unavailable.', 'Mae’n ymddangos nad yw’r gwasanaeth hwn ar gael ar hyn o bryd.'],
            ['Job list loaded - fixing page', 'Rhestr swyddi wedi ei lwytho - trwsio\'r tudalen'],
            ['Job list not loaded - trying again in', 'Rhestr swyddi ddim wedi ei lwytho - ceisio eto yn'],
            ['Please try again soon.', 'Rhowch gynnig arall arni yn fuan.'],
            ['Service Unavailable', 'Nid yw’r gwasanaeth ar gael'],
            ['This service is constantly monitored, so we have already been notified.', 'Caiff y gwasanaeth hwn ei fonitro’n gyson felly rydym ni eisoes wedi cael ein hysbysu.']
        ]);

    function fixJobList() {
        if (isLoaded()) {
            console.log(i18n('Job list loaded - fixing page'));
            $('#job-search-ajax-loader').hide();
            fixUrls();
            if (mode === 'table') {
                changeZindexOfTableElements();
                makeTableResponsive();
                addSortIconsToTableHeaders();
                $('#PSOFOShop').removeClass('d-none');
            } else {
                convertTableRowsToCards();
                addCardResizers();
                $('#Lst-NoJob').appendTo('#job-cards');
            }
            maybeEmitEventForSearchResults();
        } else {
            console.log(`${i18n('Job list not loaded - trying again in')} ${retryDelay} ms`);
            elapsedTime = elapsedTime + retryDelay;

            if (elapsedTime > timeout) {
                displayServiceUnavailableMessage();
            } else {
                setTimeout(function() {
                    fixJobList();
                }, retryDelay);
                retryDelay = retryDelay + 100;
            }
        }
    }

    function isLoaded() {
        return $('#LstContent').length >= 1;
    }

    function i18n(text) {
        if ($().isWelshPage() && dictionary.has(text)) {
            return dictionary.get(text);
        } else {
            return text;
        }
    }

    function fixUrls() {
        fixUrlsInColumnTitles();
        fixUrlsInJobDetailsLinks();
    }

    function fixUrlsInColumnTitles() {
        $('.Lst-Header a').each(function() {
            var $this = $(this),
                originalHref = $this.attr('href'),
                newHref = originalHref.replace(/list\.(aspx|php)/, '');

            $this.attr('href', newHref);
        });
    }

    function fixUrlsInJobDetailsLinks() {
        var listPageUrl = new URL(window.location.toString()),
            base        = `${listPageUrl.protocol}/${listPageUrl.host}${listPageUrl.pathname}`,
            lg          = listPageUrl.searchParams.get('lg'),
            mask        = listPageUrl.searchParams.get('mask');

        $('.lstA-desc1, .lstA-desc2').each(function() {
            var $this = $(this),
                originalUrl      = new URL($this.attr('href'), base),
                nPostingID       = originalUrl.searchParams.get('nPostingID'),
                nPostingTargetID = originalUrl.searchParams.get('nPostingTargetID'),
                ID               = originalUrl.searchParams.get('ID'),
                queryString      = [
                    `nPostingID=${nPostingID}`,
                    `nPostingTargetID=${nPostingTargetID}`,
                    `ID=${ID}`,
                    `lg=${lg}`,
                    `mask=${mask}`
                ].join('&'),
                newHref          = `details/?${queryString}`;

            $this.attr('href', newHref);
        });
    }

    function changeZindexOfTableElements() {
        var $TableHeadingLink = $('.Lst-Subheading'),
            $TableJobLink = $('#TableJobs td a');

        $($TableHeadingLink).attr('tabindex', 0);
        $($TableJobLink).attr('tabindex', 0);
    }

    function makeTableResponsive() {
        $('#TableJobs').addClass('table-responsive');
        $('.Lst-Tabel').addClass('table');
    }

    function addSortIconsToTableHeaders() {
        $('#TableJobs th').append(' <i class="fa-sharp fa-light fa-sort"></i>');
    }

    function convertTableRowsToCards() {
        var $jobsListEmbedCode = $('.col-md-12.su-embed-code').eq(1);
        $jobsListEmbedCode.parent().append(`
            <div class="col-lg-12">
                <div class="container">
                    <div id="job-cards" class="row">
                    </div>
                </div>
            </div>`);

        $('#TableJobs tr').slice(1, -1).each(function() {
            var $this = $(this),
                $td   = $this.find('td'),
                jobTitle = $td.eq(0).find('a').eq(0).text().trim(),
                url = $td.eq(0).find('a').attr('href'),
                facultyDirectorate = $td.eq(1).text().trim(),
                school = $td.eq(2).text().trim(),
                closingDate = $td.eq(3).text().trim(),
                card = `
                    <div class="job-cards-item col-md-6 col-xl-4">
                       <div class="card">
                           <h2 class="card-header d-flex align-items-center justify-content-center text-center h-33">${jobTitle}</h2>
                           <div class="card-body flex-column h-100">
                               <p class="h-33 font-weight-bold mb-2">${facultyDirectorate}</p>
                               <p class="h-33 mb-3">${school}</p>
                                <a href="${url}" class="btn btn-primary">${i18n('Details')}</a>
                           </div>
                           <div class="card-footer">
                               <p class="font-weight-bold text-center mb-0">${i18n('Closing Date')}: ${closingDate}</p>
                           </div>
                       </div>
                    </div>`;
            $('#job-cards').append(card);
        });

        $jobsListEmbedCode.hide();
    }

    function addCardResizers() {
        const $jobCardsItems = $('.job-cards-item');

        $('#grid-small-cards').on('click', function(e) {
            e.preventDefault();
            $jobCardsItems.removeAttr('class').addClass('job-cards-item col-md-6 col-xl-4');
        });
        $('#grid-large-cards').on('click', function(e) {
            e.preventDefault();
            $jobCardsItems.removeAttr('class').addClass('job-cards-item col-12 col-md-6');
        });
        $('#grid-list-cards').on('click', function(e) {
            e.preventDefault();
            $jobCardsItems.removeAttr('class').addClass('job-cards-item col-12');
        });
    }

    function displayServiceUnavailableMessage() {
        $('#job-search-ajax-loader').hide();
        $('#PSOFOShop').append(`
            <h3>${i18n('Service Unavailable')}</h3>
            <p>${i18n('It appears that this service is currently unavailable.')}</p>
            <p>${i18n('This service is constantly monitored, so we have already been notified.')}</p>
            <p>${i18n('Please try again soon.')}</p>
        `).removeClass('d-none');
    }

    function maybeEmitEventForSearchResults() {
        var params              = new URLSearchParams(location.search),
            criteria            = [],
            contractType        = params.get('ContractType'),
            jobFamily           = params.get('LOV4'),
            collegeOrDepartment = params.get('LOV5'),
            matchingResults     = $('.Lst-NoJobs').length > 0 ? 0 : $('.Lst-NavPage').text().match(/(\d+ (to|hyd at) )?(\d+)/)[3];

        if (contractType !== 'All') {
            criteria.push({
                name:  'ContractType',
                type:  'CATEGORY',
                value: contractType
            });
        }

        if (jobFamily !== 'All') {
            criteria.push({
                name:  'LOV4',
                type:  'LOV',
                value: jobFamily,
                id:    4
            });
        }

        if (collegeOrDepartment !== 'All') {
            criteria.push({
                name:  'LOV5',
                type:  'LOV',
                value: collegeOrDepartment,
                id:    5
            });
        }

        if (criteria.length && typeof lumesseAnalytics === 'object') {
            console.log('Emit event for SearchResultsViewed');
            lumesseAnalytics.init({
                trackingUrl: 'https://journey-service.tb.lumesse.com/acq',
                analyticUrl: 'https://message-broker.tb.lumesse.com/message/emea3_advert_interactions',
                technicalIdentifier: params.get('ID')
            });
            lumesseAnalytics.pushEvent('SearchResultsViewed', {
                atsLanguageCode: params.get('lg'),
                clientId:        'MTU374',
                matchingResults,
                criteria
            });
        }
    }

    function fixFacets() {
        removeExcessBottomMargin();
        fixUrlsInFacets();
    }

    function removeExcessBottomMargin() {
        $('.su-embed-code').addClass('mb-0');
    }

    function fixUrlsInFacets() {
        $('.site-search-facets-facet-categories').each(function() {
            fixUrlsInFacet($(this));
        });
    }

    function fixUrlsInFacet($facet) {
        var filterApplied = false,
            $itemLinks = $facet.find('.site-search-facets-facet-categories-item-link'),
            $subItemLinks = $facet.find('.site-search-facets-facet-categories-item-sub-item-link');

        $itemLinks.each(function() {
            var $itemLink = $(this),
                params = new URLSearchParams(location.search),
                key = $itemLink.attr('data-filter-name'),
                value = $itemLink.attr('data-filter-value');

            if (params.get(key) === value) {
                filterApplied = true;
                $itemLink.addClass('selected');
                params.set(key, 'All');
            } else {
                params.set(key, value);
                if ($subItemLinks.length > 0) {
                    const childKey = $subItemLinks.eq(0).attr('data-filter-name');
                    params.set(childKey, 'All');
                }
            }
            $itemLink.attr('href', '?' + params);

            fixUrlsForSubItemsInFacetItem($itemLink);
        });

        if (filterApplied) {
            const $appliedFilters = $('.applied-filters');
            $itemLinks.each(function() {
                const $itemLink = $(this);
                if ($itemLink.hasClass('selected')) {
                    $itemLink
                        .clone()
                        .attr('class', 'btn btn-outline-primary-alt btn-sm rounded m-2')
                        .append('&nbsp;<i class="fa-sharp fa-light fa-circle-xmark"></i>').appendTo($appliedFilters);
                }
            });
        }
    }

    function fixUrlsForSubItemsInFacetItem($itemLink) {
        var filterApplied = false,
            parentKey = $itemLink.attr('data-filter-name'),
            $subItemLinks = $itemLink.parent().find('.site-search-facets-facet-categories-item-sub-item a');

        $subItemLinks.each(function() {
            var $subItemLink = $(this),
                params = new URLSearchParams(location.search),
                key = $subItemLink.attr('data-filter-name'),
                value = $subItemLink.attr('data-filter-value');

            if (params.get(key) === value) {
                filterApplied = true;
                $subItemLink.addClass('selected');
                params.set(key, 'All');
            } else {
                params.set(key, value);
                params.set(parentKey, 'All');
            }

            $subItemLink.attr('href', '?' + params);
        });

        if (filterApplied) {
            const $appliedFilters = $('.applied-filters');
            $itemLink.parent().find('.site-search-facets-facet-categories-item-sub-item .selected').each(function() {
                const
                    $appliedFilter = $(this).clone(),
                    filterAltText = $appliedFilter.attr('data-filter-alt-text');
                if (filterAltText) {
                    $appliedFilter.text(filterAltText);
                }
                $appliedFilter
                    .attr('class', 'btn btn-outline-primary-alt btn-sm rounded m-2')
                    .append('&nbsp;<i class="fa-sharp fa-light fa-circle-xmark"></i>').appendTo($appliedFilters);
            });
        }
    }

    fixJobList();
    fixFacets();
});
